import React from "react";
import SelectTextEdit from "./fields/SelectTextEdit";
import {complexities, counts, lengths, solveTypes, speeds, taskTypes, themes} from "../../common/themes";
import SliderComponent from "./fields/SliderComponent";
import "./HomeworkSetting.sass"
import PropTypes from "prop-types";

export default function HomeworkSetting(props) {

    const {
        theme,
        setTheme,
        disabledTheme,
        solveType,
        setSolveType,
        disabledSolveType,
        taskType,
        setTaskType,
        disabledTaskType,
        complexity,
        setComplexity,
        speed,
        setSpeed,
        length,
        setLength,
        count,
        setCount,
        isShowCount,
    } = props;

    return (
        <div className="HomeworkSetting-main">
            <div className="HomeworkSetting-main-top">
                <SelectTextEdit
                    disabled={disabledTheme}
                    className="HomeworkSetting-main-top-select"
                    value={theme}
                    onChange={e => setTheme(e.target.value)}
                    label="Тема"
                    data={themes}/>
                <SelectTextEdit
                    disabled={disabledSolveType}
                    className="HomeworkSetting-main-top-select"
                    value={solveType}
                    onChange={e => setSolveType(e.target.value)}
                    label="Как решать"
                    data={solveTypes}/>
                <SelectTextEdit
                    disabled={disabledTaskType}
                    className="HomeworkSetting-main-top-select"
                    value={taskType}
                    onChange={e => setTaskType(e.target.value)}
                    label="Тип примера"
                    data={taskTypes}/>
            </div>
            <fieldset className="HomeworkSetting-main-item">
                <legend>Сложность</legend>
                <div>
                    <SliderComponent marks={complexities}
                                     min={0} max={4}
                                     value={complexity}
                                     onChange={e => setComplexity(e.target.value)}/>
                </div>
            </fieldset>
            <fieldset className="HomeworkSetting-main-item">
                <legend>Скорость</legend>
                <div>
                    <SliderComponent marks={speeds}
                                     min={0.1} max={10}
                                     step={0.1}
                                     value={speed}
                                     onChange={e => setSpeed(e.target.value)}
                                     valueLabelDisplay="auto"/>
                </div>
            </fieldset>
            <fieldset className="HomeworkSetting-main-item">
                <legend>Количество чисел</legend>
                <div>
                    <SliderComponent marks={lengths}
                                     min={1} max={100}
                                     value={length}
                                     onChange={e => setLength(e.target.value)}
                                     valueLabelDisplay="auto"/>
                </div>
            </fieldset>
            {
                isShowCount && <fieldset className="HomeworkSetting-main-item">
                    <legend>Количество примеров</legend>
                    <div>
                        <SliderComponent marks={counts}
                                         min={1} max={100}
                                         value={count}
                                         onChange={e => setCount(e.target.value)}
                                         valueLabelDisplay="auto"/>
                    </div>
                </fieldset>
            }
        </div>
    )
}

HomeworkSetting.propTypes = {
    theme: PropTypes.string,
    setTheme: PropTypes.func.isRequired,
    disabledTheme: PropTypes.bool,
    solveType: PropTypes.string,
    setSolveType: PropTypes.func.isRequired,
    disabledSolveType: PropTypes.bool,
    taskType: PropTypes.string,
    setTaskType: PropTypes.func.isRequired,
    disabledTaskType: PropTypes.bool,
    complexity: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    setComplexity: PropTypes.func.isRequired,
    speed: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    setSpeed: PropTypes.func.isRequired,
    length: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    setLength: PropTypes.func.isRequired,
    count: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    setCount: PropTypes.func,
    isShowCount: PropTypes.bool,
}